import type { ReduxApplicationState } from '../combinedReducer';

/** Text for the page's visually hidden live region, announcing state changes. */
export const selectPageLiveRegionText = (state: ReduxApplicationState) =>
  state.accessibility.statusMessage;
